/* eslint-disable no-undef */
import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
    },
    getters: {
        defauleSearchSchema:(state)=>{
            return state.defauleSearchSchema;
        }
    },
    mutations: {
        // 设置保存搜索方案
        setSavedSearchSchemas(state, newValue) {
            if(Array.isArray(newValue)) {
                console.log(newValue);
                Vue.set(state, 'savedSearchSchemas', [...newValue]);
            }  
        },
    },
    actions: {
        async getSpaces({commit}, {data, handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.get(ApiUrl.space.index, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async newSpace({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.post(ApiUrl.space.new,null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async modifySpace({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.put(ApiUrl.space.edit,null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async delSpace({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.delete(ApiUrl.space.del,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async spaceDetail({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.get(ApiUrl.space.info,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getSpecials({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.get(ApiUrl.space.special,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async collectSpecials({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.post(ApiUrl.space.collect, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async removeSpecials({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.delete(ApiUrl.space.cancel, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async addShare({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
            
                const rsp = await axios.post(ApiUrl.space.addShare, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getDescList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.space.getdesc, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async addDesc({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.space.adddesc, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async updateDesc({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.put(ApiUrl.space.updesc, null, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async deleteDesc({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.delete(ApiUrl.space.deldesc, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async getSharedSpaceList({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.space.sharedList, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async addNewSharedSpace({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.post(ApiUrl.space.createShare, null,data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async delSharedSpace({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.delete(ApiUrl.space.delShare, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
        async searchUserInfo({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.space.searchUser, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        },
    }
}

